<template>
	<div class="row">
		<div id="content" class="col-sm-12 col-lg-8">
			<Welcome
				title="Claims"
				description="Below is a list of all the claims that you have submitted."
			/>
			<loading v-if="loading" />
			<alert type="danger" v-if="error && !loading"
				>There was an issue trying to recieve your existing claims.</alert
			>
			<p v-if="claims.length <= 0 && !loading && !error">There are no claims</p>
			<div class="table-responsive">
				<table class="table table-striped" v-if="claims.length > 0 && !loading && !error">
					<thead>
						<tr>
							<th>Date Submitted</th>
							<th>Status</th>
							<th>Web ID</th>
							<th>Claim #</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(claim, index) in claims" :key="index">
							<td>{{ claim.date_submitted | moment('MM/D/YYYY') }}</td>
							<td>{{ claim.claim_status }}</td>
							<td>{{ claim.claim_id }}</td>
							<td>{{ claim.real_claim_id }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<sidebar />
	</div>
</template>

<script>
import { Component, Mixins, Vue } from 'vue-property-decorator';

// Mixin
import ClaimsMixin from '@/mixins/Claims/Claims';
import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';

@Component({
	name: 'PageClaims',
	components: {
		Alert,
		Welcome,
	},
})
export default class Claims extends Mixins(ClaimsMixin) {}
</script>
